import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {getCurrentMicroTime} from "reducers/timeMeasuring/actions";
import 'rc-slider/assets/index.css';
import DragDrop from "./PresentationTypeDragAndDrop/DragDrop";

class PresentationTypeDragAndDrop extends Component {

  constructor(props){
    super(props);

    this.handlerDrop = this.handlerDrop.bind(this);
  }

  handlerDrop(answer, value){
    const microTime = getCurrentMicroTime(this.props.startTime);

    const detail = {
      ...detail,
      microTime,
      answer,
      value1: value
    };

    this.props.onDetailChange(detail, answer);
  }

  render() {
    const {details, question} = this.props;

    return <DragDrop question={question} details={details} handleDrop={this.handlerDrop} />
  }
}

PresentationTypeDragAndDrop.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
    }),).isRequired,
    required: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['input', 'slider', 'dragAndDrop']).isRequired,
    answersImage: PropTypes.bool.isRequired,
    summaryMax: PropTypes.number.isRequired,
    summaryVisibility: PropTypes.bool.isRequired,
    valueText: PropTypes.string,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    value1: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  onDetailChange: PropTypes.func.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true})(PresentationTypeDragAndDrop);